(function () {
  'use strict';

  var STORAGE_KEY = 'shs-warranty-claim';
  var MAX_FILE_SIZE = 5 * 1024 * 1024;
  var ALLOWED_TYPES = [
    'image/jpeg', 'image/png', 'image/webp', 'image/heic', 'application/pdf'
  ];
  var TOTAL_STEPS = 5;

  var SAUNA_COMPONENTS = [
    'Heater', 'Control Panel / Power Box', 'LED Lighting', 'Glass Door',
    'Audio / Bluetooth', 'Cabinetry', 'Exterior Cabin', 'Red Light Therapy',
    'Wi-Fi / App', 'Wiring / Power Cord', 'Door Seal', 'Other'
  ];
  var COLD_PLUNGE_COMPONENTS = [
    'Chiller / Compressor', 'Water Pump', 'Control Panel', 'Filter',
    'UV / Ozone', 'Hoses / Fittings', 'Tub Shell', 'Tub Cover',
    'Wi-Fi / App', 'Other'
  ];
  var ACCESSORY_COMPONENTS = [
    'LED / Light Array', 'Battery / Charging', 'Heating Element',
    'Controller', 'Mounting Hardware', 'Other'
  ];
  var ACCESSORY_VALUES = [
    'Red Light Face Mask', 'Red Light Therapy Panel', 'Sauna Blanket'
  ];

  var currentStep = 1;
  var fileStore = { purchase_proof: [], issue_photos: [] };

  var form = document.getElementById('warranty-claim-form');
  if (!form) return;

  var endpoint = form.dataset.endpoint;
  var steps = form.querySelectorAll('.wc-step');
  var progressFill = form.querySelector('.wc-progress__fill');
  var progressSteps = form.querySelectorAll('.wc-progress__step');
  var btnBack = form.querySelector('.wc-nav__btn--back');
  var btnNext = form.querySelector('.wc-nav__btn--next');
  var btnSubmit = form.querySelector('.wc-nav__btn--submit');
  var successEl = document.getElementById('wc-success');
  var errorEl = document.getElementById('wc-error');
  var resumeBanner = document.getElementById('wc-resume');
  var productSelect = document.getElementById('wc-product-model');
  var componentSelect = document.getElementById('wc-component');

  init();

  function init() {
    bindNavigation();
    bindProductChange();
    bindUploads();
    bindFieldPersistence();
    checkSavedState();
  }

  /* ── Navigation ─────────────────────────────────────────────── */

  function bindNavigation() {
    btnNext.addEventListener('click', nextStep);
    btnBack.addEventListener('click', prevStep);
    btnSubmit.addEventListener('click', submitForm);

    progressSteps.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = parseInt(btn.dataset.step, 10);
        if (target < currentStep) goToStep(target);
      });
    });
  }

  function nextStep() {
    if (!validateStep(currentStep)) return;
    goToStep(currentStep + 1);
  }

  function prevStep() {
    goToStep(currentStep - 1);
  }

  function goToStep(step) {
    if (step < 1 || step > TOTAL_STEPS) return;
    currentStep = step;

    steps.forEach(function (s) {
      var n = parseInt(s.dataset.step, 10);
      if (n === step) {
        s.classList.add('wc-step--active');
      } else {
        s.classList.remove('wc-step--active');
      }
    });

    progressFill.style.width = (step / TOTAL_STEPS * 100) + '%';
    form.querySelector('.wc-progress').setAttribute('aria-valuenow', step);

    progressSteps.forEach(function (s) {
      var n = parseInt(s.dataset.step, 10);
      s.classList.toggle('wc-progress__step--active', n === step);
      s.classList.toggle('wc-progress__step--done', n < step);
    });

    btnBack.style.visibility = step === 1 ? 'hidden' : 'visible';
    btnNext.style.display = step === TOTAL_STEPS ? 'none' : '';
    btnSubmit.style.display = step === TOTAL_STEPS ? '' : 'none';

    if (step === TOTAL_STEPS) buildReview();

    form.scrollIntoView({ behavior: 'smooth', block: 'start' });
    saveState();
  }

  /* ── Validation ─────────────────────────────────────────────── */

  function validateStep(step) {
    var stepEl = form.querySelector('.wc-step[data-step="' + step + '"]');
    var required = stepEl.querySelectorAll('[required]');
    var valid = true;
    var firstError = null;

    clearErrors(stepEl);

    var checkedRadioGroups = {};

    required.forEach(function (field) {
      if (field.type === 'radio') {
        if (checkedRadioGroups[field.name]) return;
        checkedRadioGroups[field.name] = true;
        var checked = stepEl.querySelector('input[name="' + field.name + '"]:checked');
        if (!checked) {
          var fieldset = field.closest('fieldset');
          if (fieldset) {
            fieldset.classList.add('wc-radio-group--error');
            appendError(fieldset, 'Please select an option');
            valid = false;
            if (!firstError) firstError = fieldset;
          }
        }
        return;
      }

      if (field.type === 'checkbox') {
        if (!field.checked) {
          markFieldError(field, 'This field is required');
          valid = false;
          if (!firstError) firstError = field;
        }
        return;
      }

      if (!field.value.trim()) {
        markFieldError(field, 'This field is required');
        valid = false;
        if (!firstError) firstError = field;
        return;
      }

      if (field.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(field.value)) {
        markFieldError(field, 'Please enter a valid email address');
        valid = false;
        if (!firstError) firstError = field;
      }
    });

    if (firstError) {
      firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var focusTarget = firstError.querySelector('input, select, textarea') || firstError;
      if (focusTarget.focus) focusTarget.focus();
    }

    return valid;
  }

  function clearErrors(container) {
    container.querySelectorAll('.field--error').forEach(function (f) {
      f.classList.remove('field--error');
    });
    container.querySelectorAll('.wc-field-error').forEach(function (e) {
      e.remove();
    });
    container.querySelectorAll('.wc-radio-group--error').forEach(function (g) {
      g.classList.remove('wc-radio-group--error');
    });
  }

  function markFieldError(field, message) {
    var wrapper = field.closest('.field') || field.closest('.wc-acknowledgment');
    if (wrapper) wrapper.classList.add('field--error');
    appendError(field.parentNode, message);
  }

  function appendError(parent, message) {
    var err = document.createElement('small');
    err.className = 'wc-field-error';
    err.textContent = message;
    parent.appendChild(err);
  }

  /* ── Product → Component mapping ────────────────────────────── */

  function bindProductChange() {
    productSelect.addEventListener('change', updateComponents);
  }

  function updateComponents() {
    var model = productSelect.value;
    var components = [];

    if (model.indexOf('Cold Plunge') !== -1) {
      components = COLD_PLUNGE_COMPONENTS;
    } else if (ACCESSORY_VALUES.indexOf(model) !== -1) {
      components = ACCESSORY_COMPONENTS;
    } else if (model) {
      components = SAUNA_COMPONENTS;
    }

    componentSelect.innerHTML = '<option value="">Select a component</option>';
    components.forEach(function (c) {
      var opt = document.createElement('option');
      opt.value = c;
      opt.textContent = c;
      componentSelect.appendChild(opt);
    });
  }

  /* ── File uploads ───────────────────────────────────────────── */

  function bindUploads() {
    form.querySelectorAll('.wc-upload').forEach(function (upload) {
      var key = upload.dataset.upload;
      var maxFiles = parseInt(upload.dataset.maxFiles, 10) || 5;
      var zone = upload.querySelector('.wc-upload__zone');
      var input = upload.querySelector('.wc-upload__input');
      var previews = upload.querySelector('.wc-upload__previews');

      zone.addEventListener('click', function () { input.click(); });
      zone.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          input.click();
        }
      });

      zone.addEventListener('dragover', function (e) {
        e.preventDefault();
        zone.classList.add('wc-upload__zone--dragover');
      });
      zone.addEventListener('dragleave', function () {
        zone.classList.remove('wc-upload__zone--dragover');
      });
      zone.addEventListener('drop', function (e) {
        e.preventDefault();
        zone.classList.remove('wc-upload__zone--dragover');
        handleFiles(key, Array.from(e.dataTransfer.files), maxFiles, previews);
      });

      input.addEventListener('change', function () {
        handleFiles(key, Array.from(input.files), maxFiles, previews);
        input.value = '';
      });
    });
  }

  function handleFiles(key, newFiles, maxFiles, previewsEl) {
    for (var i = 0; i < newFiles.length; i++) {
      var file = newFiles[i];

      if (fileStore[key].length >= maxFiles) {
        showTempError(previewsEl, 'Maximum ' + maxFiles + ' file(s) allowed');
        return;
      }
      if (file.size > MAX_FILE_SIZE) {
        showTempError(previewsEl, file.name + ' exceeds the 5 MB limit');
        continue;
      }
      if (ALLOWED_TYPES.indexOf(file.type) === -1 && !(/\.heic$/i).test(file.name)) {
        showTempError(previewsEl, file.name + ' is not a supported file type');
        continue;
      }

      (function (f) {
        var reader = new FileReader();
        reader.onload = function (e) {
          var data = {
            filename: f.name,
            contentType: f.type,
            size: f.size,
            base64: e.target.result.split(',')[1]
          };
          fileStore[key].push(data);
          renderPreview(key, data, fileStore[key].length - 1, previewsEl);
        };
        reader.readAsDataURL(f);
      })(file);
    }
  }

  function renderPreview(key, fileData, index, container) {
    var el = document.createElement('div');
    el.className = 'wc-upload__preview';

    if (fileData.contentType && fileData.contentType.indexOf('image/') === 0) {
      var img = document.createElement('img');
      img.src = 'data:' + fileData.contentType + ';base64,' + fileData.base64;
      img.alt = fileData.filename;
      el.appendChild(img);
    } else {
      var icon = document.createElement('span');
      icon.className = 'wc-upload__file-icon';
      icon.textContent = fileData.filename.split('.').pop().toUpperCase();
      el.appendChild(icon);
    }

    var name = document.createElement('span');
    name.className = 'wc-upload__filename';
    name.textContent = fileData.filename;
    el.appendChild(name);

    var remove = document.createElement('button');
    remove.type = 'button';
    remove.className = 'wc-upload__remove';
    remove.textContent = '×';
    remove.setAttribute('aria-label', 'Remove ' + fileData.filename);
    remove.addEventListener('click', function () {
      fileStore[key].splice(index, 1);
      container.innerHTML = '';
      fileStore[key].forEach(function (f, i) {
        renderPreview(key, f, i, container);
      });
    });
    el.appendChild(remove);

    container.appendChild(el);
  }

  function showTempError(el, message) {
    var existing = el.parentNode.querySelector('.wc-field-error');
    if (existing) existing.remove();
    var err = document.createElement('small');
    err.className = 'wc-field-error';
    err.textContent = message;
    el.parentNode.appendChild(err);
    setTimeout(function () { if (err.parentNode) err.remove(); }, 5000);
  }

  /* ── localStorage persistence ───────────────────────────────── */

  function bindFieldPersistence() {
    form.querySelectorAll('input, select, textarea').forEach(function (field) {
      if (field.type === 'file' || field.name === 'company') return;
      field.addEventListener('change', saveState);
      field.addEventListener('input', debounce(saveState, 500));
    });
  }

  function saveState() {
    var data = { step: currentStep, fields: {} };
    form.querySelectorAll('input, select, textarea').forEach(function (field) {
      if (field.type === 'file' || field.name === 'company' || !field.name) return;
      if (field.type === 'radio') {
        if (field.checked) data.fields[field.name] = field.value;
      } else if (field.type === 'checkbox') {
        data.fields[field.id] = field.checked;
      } else {
        data.fields[field.id || field.name] = field.value;
      }
    });
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (e) { /* quota exceeded */ }
  }

  function checkSavedState() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return;
      var data = JSON.parse(raw);
      if (!data.fields || Object.keys(data.fields).length === 0) return;

      resumeBanner.style.display = '';

      document.getElementById('wc-resume-restore').addEventListener('click', function () {
        restoreState(data);
        resumeBanner.style.display = 'none';
      });
      document.getElementById('wc-resume-discard').addEventListener('click', function () {
        localStorage.removeItem(STORAGE_KEY);
        resumeBanner.style.display = 'none';
      });
    } catch (e) { /* corrupt data */ }
  }

  function restoreState(data) {
    var key, value, field, radio;
    for (key in data.fields) {
      if (!data.fields.hasOwnProperty(key)) continue;
      value = data.fields[key];
      field = document.getElementById(key) || form.querySelector('input[name="' + key + '"]');
      if (!field) continue;

      if (field.type === 'radio') {
        radio = form.querySelector('input[name="' + key + '"][value="' + value + '"]');
        if (radio) radio.checked = true;
      } else if (field.type === 'checkbox') {
        field.checked = value;
      } else {
        field.value = value;
      }
    }

    if (productSelect.value) updateComponents();

    var savedComponent = data.fields['wc-component'];
    if (savedComponent) {
      setTimeout(function () { componentSelect.value = savedComponent; }, 0);
    }

    if (data.step && data.step > 1) goToStep(data.step);
  }

  /* ── Review ─────────────────────────────────────────────────── */

  function buildReview() {
    var reviewEl = document.getElementById('wc-review-summary');
    var sections = [
      {
        title: 'Your Information',
        items: [
          { label: 'Name', value: val('wc-first-name') + ' ' + val('wc-last-name') },
          { label: 'Email', value: val('wc-email') },
          { label: 'Phone', value: val('wc-phone') },
          { label: 'Address', value: [val('wc-address'), val('wc-city'), val('wc-state'), val('wc-zip'), getCountryLabel()].filter(Boolean).join(', ') }
        ]
      },
      {
        title: 'Order & Product',
        items: [
          { label: 'Order Number', value: val('wc-order-number') },
          { label: 'Product', value: val('wc-product-model') },
          { label: 'Serial Number', value: val('wc-serial-number') },
          { label: 'Delivery Date', value: formatDate(val('wc-delivery-date')) },
          { label: 'Proof of Purchase', value: fileStore.purchase_proof.length ? fileStore.purchase_proof.map(function (f) { return f.filename; }).join(', ') : '' }
        ]
      },
      {
        title: 'Issue Details',
        items: [
          { label: 'Component', value: val('wc-component') },
          { label: 'Description', value: val('wc-description') },
          { label: 'Date Noticed', value: formatDate(val('wc-date-noticed')) },
          { label: 'Error Code', value: val('wc-error-code') },
          { label: 'Troubleshooting', value: val('wc-troubleshooting') },
          { label: 'Photos', value: fileStore.issue_photos.length ? fileStore.issue_photos.map(function (f) { return f.filename; }).join(', ') : '' },
          { label: 'Video URL', value: val('wc-video-url') }
        ]
      },
      {
        title: 'Coverage Screening',
        items: [
          { label: 'Original Purchaser', value: radioLabel('original_purchaser') },
          { label: 'Residential Use', value: radioLabel('residential_use') },
          { label: 'Indoor Installation', value: radioLabel('indoor_install') },
          { label: 'Dedicated Circuit', value: radioLabel('dedicated_outlet') },
          { label: '5ft from Water', value: radioLabel('water_distance') },
          { label: 'Extended Warranty', value: radioLabel('extended_warranty') }
        ]
      }
    ];

    var html = '';
    sections.forEach(function (section) {
      var items = section.items.filter(function (i) { return i.value; });
      if (!items.length) return;
      html += '<div class="wc-review__section">';
      html += '<h4 class="wc-review__heading">' + section.title + '</h4>';
      html += '<dl class="wc-review__list">';
      items.forEach(function (item) {
        html += '<div class="wc-review__item">';
        html += '<dt>' + item.label + '</dt>';
        html += '<dd>' + escapeHtml(item.value) + '</dd>';
        html += '</div>';
      });
      html += '</dl></div>';
    });

    reviewEl.innerHTML = html;
  }

  function val(id) {
    var el = document.getElementById(id);
    return el ? el.value.trim() : '';
  }

  function radioLabel(name) {
    var el = form.querySelector('input[name="' + name + '"]:checked');
    if (!el) return '';
    var v = el.value;
    return v.charAt(0).toUpperCase() + v.slice(1);
  }

  function getCountryLabel() {
    var sel = document.getElementById('wc-country');
    if (!sel || !sel.value) return '';
    return sel.options[sel.selectedIndex].textContent;
  }

  function formatDate(dateStr) {
    if (!dateStr) return '';
    var parts = dateStr.split('-');
    if (parts.length !== 3) return dateStr;
    return parts[1] + '/' + parts[2] + '/' + parts[0];
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  /* ── Submission ─────────────────────────────────────────────── */

  function submitForm() {
    // Validate every step, not just step 5 — bounce back to the first
    // step with an error so the user can fix it without guessing where.
    for (var s = 1; s <= TOTAL_STEPS; s++) {
      // Make the target step visible BEFORE validating so the focus
      // and scroll calls in validateStep land on the right element.
      if (s !== currentStep) {
        var prev = form.querySelector('.wc-step[data-step="' + currentStep + '"]');
        var next = form.querySelector('.wc-step[data-step="' + s + '"]');
        if (prev) prev.classList.remove('wc-step--active');
        if (next) next.classList.add('wc-step--active');
      }
      if (!validateStep(s)) {
        goToStep(s);
        return;
      }
    }

    // All steps valid — make sure step 5 is the visible/active one
    if (currentStep !== TOTAL_STEPS) goToStep(TOTAL_STEPS);

    var honeypot = document.getElementById('wc-company');
    if (honeypot && honeypot.value) {
      showSuccess('wc_submitted');
      return;
    }

    setBusy(true);
    errorEl.style.display = 'none';

    var fullName = (val('wc-first-name') + ' ' + val('wc-last-name')).trim();

    var payload = {
      name: fullName,
      email: val('wc-email'),
      phone: val('wc-phone'),
      address: val('wc-address'),
      city: val('wc-city'),
      state: val('wc-state'),
      zip: val('wc-zip'),
      country: val('wc-country'),
      orderNumber: val('wc-order-number'),
      productModel: val('wc-product-model'),
      serialNumber: val('wc-serial-number'),
      deliveryDate: val('wc-delivery-date'),
      component: val('wc-component'),
      description: val('wc-description'),
      dateNoticed: val('wc-date-noticed'),
      errorCode: val('wc-error-code'),
      troubleshooting: val('wc-troubleshooting'),
      videoUrl: val('wc-video-url'),
      originalPurchaser: radioLabel('original_purchaser'),
      residentialUse: radioLabel('residential_use'),
      indoorInstall: radioLabel('indoor_install'),
      dedicatedOutlet: radioLabel('dedicated_outlet'),
      distanceFromWater: radioLabel('water_distance'),
      extendedWarranty: radioLabel('extended_warranty'),
      acknowledgment: document.getElementById('wc-acknowledge').checked,
      _hp: honeypot ? honeypot.value : '',
      files: fileStore.purchase_proof.concat(fileStore.issue_photos)
    };

    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok || !data.ok) {
            var msg = '';
            if (Array.isArray(data.errors) && data.errors.length) {
              msg = data.errors.join('. ');
            } else if (data.error) {
              msg = data.error;
            } else {
              msg = 'Something went wrong. Please try again.';
            }
            throw new Error(msg);
          }
          return data;
        });
      })
      .then(function (data) {
        showSuccess(data.reference);
      })
      .catch(function (err) {
        errorEl.style.display = '';
        document.getElementById('wc-error-message').textContent =
          err.message || 'Unable to submit. Please try again or contact us directly at info@sunhomesaunas.com.';
        setBusy(false);
      });
  }

  function showSuccess(ref) {
    document.getElementById('wc-ref-number').textContent = ref;

    var hideSelectors = [
      '.wc-step', '.wc-progress', '.wc-nav', '.wc-resume', '.wc-error'
    ];
    hideSelectors.forEach(function (sel) {
      form.querySelectorAll(sel).forEach(function (el) { el.style.display = 'none'; });
    });

    successEl.style.display = '';
    localStorage.removeItem(STORAGE_KEY);
    form.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function setBusy(busy) {
    btnSubmit.disabled = busy;
    btnSubmit.querySelector('.wc-nav__btn-text').style.display = busy ? 'none' : '';
    btnSubmit.querySelector('.wc-nav__btn-spinner').style.display = busy ? '' : 'none';

    form.querySelectorAll('input, select, textarea, button').forEach(function (el) {
      if (el !== btnSubmit) el.disabled = busy;
    });
  }

  /* ── Utilities ──────────────────────────────────────────────── */

  function debounce(fn, ms) {
    var timer;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(fn, ms);
    };
  }
})();
